import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from "@angular/common/http";
import {Observable, finalize} from "rxjs";
import {environment} from "../../../environments/environment";
import {LoadingService} from "../services/loading.service";

@Injectable()
export class LoadingInterceptor implements HttpInterceptor {
    constructor(private loadingService: LoadingService) {
    }

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        if (!this.isBackendRequest(request.url)) {
            return next.handle(request);
        }

        const requestId = this.buildRequestId(request);
        const requestLabel = `${request.method} ${request.urlWithParams}`;
        this.loadingService.requestStarted(requestId, requestLabel);

        return next.handle(request).pipe(
            finalize(() => this.loadingService.requestFinished(requestId))
        );
    }

    private isBackendRequest(url: string): boolean {
        const normalizedBaseApiUrl = (environment.baseApiURL || '').replace(/\/+$/, '');
        const normalizedRequestUrl = (url || '').replace(/\/+$/, '');

        if (!normalizedBaseApiUrl) {
            return normalizedRequestUrl.includes('/api/');
        }

        return normalizedRequestUrl.startsWith(normalizedBaseApiUrl);
    }

    private buildRequestId(request: HttpRequest<unknown>): string {
        return `${request.method}-${request.urlWithParams}-${Date.now()}-${Math.random().toString(36).slice(2)}`;
    }
}
